__turbopack_context__.v({
  "message": "kHMDtq_message",
  "message__button": "kHMDtq_message__button",
  "message__header": "kHMDtq_message__header",
  "message__text": "kHMDtq_message__text",
});
